import { render, staticRenderFns } from "./VField.vue?vue&type=template&id=5db0233a&scoped=true&"
import script from "./VField.vue?vue&type=script&lang=js&"
export * from "./VField.vue?vue&type=script&lang=js&"
import style0 from "./VField.vue?vue&type=style&index=0&id=5db0233a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0233a",
  null
  
)

export default component.exports